import React from 'react';

import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ReactHookFormIntlNumberInput } from 'common/components/form';

import { getHasBagEnergyField, getSectionHasErrors } from '../../helpers';
import * as selectors from '../../selectors';

import FormAccordion from './FormAccordion';

const NetMeteringFields = ({
    compensationScheme,
    control,
    disabled,
    errors,
    isFetchingAvailableBag,
    rate,
}) => {
    const { t } = useTranslation();

    if (!getHasBagEnergyField(rate, compensationScheme)) return null;

    return (
        <FormAccordion
            defaultExpanded
            hasFormErrors={getSectionHasErrors(errors, ['applied_bag'])}
            title={t('Net metering')}
        >
            <Grid container>
                <Grid
                    alignItems={{ sm: 'center', xs: 'flex-start' }}
                    display="flex"
                    flexDirection={{ sm: 'row', xs: 'column' }}
                    gap={{ sm: 2, xs: 0 }}
                    size={{ md: 9, xs: 18 }}
                >
                    <ReactHookFormIntlNumberInput
                        allowNegativeValue={false}
                        append="kWh"
                        control={control}
                        disabled={disabled || isFetchingAvailableBag}
                        fullWidth
                        label={t('Consumed pool')}
                        min={0}
                        name="applied_bag"
                        variant="standard"
                    />
                </Grid>
            </Grid>
        </FormAccordion>
    );
};

const mapStateToProps = createStructuredSelector({
    isFetchingAvailableBag: selectors.getIsFetchingAvailableBag,
});

NetMeteringFields.propTypes = {
    compensationScheme: PropTypes.string,
    control: PropTypes.object,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    isFetchingAvailableBag: PropTypes.bool,
    rate: PropTypes.object,
};

export default connect(mapStateToProps)(NetMeteringFields);
